import { observer } from 'mobx-react';
import i_ from 'i18next';
import React from 'react';

import Table from '../commons/Table';

import Stores from '../../stores/Stores';
import UIStore from '../../stores/UIStore';

import Edit from './Edit';

const store = Stores.load('municipio');

class Municipio extends React.Component {
  componentWillMount() {
    UIStore.init(i_.t('municipio.title'), store);
  }

  handleDelete = () => {
    let count = store.selected.length;

    UIStore.showConfirmDialog(
      i_.t('dialogs.remove-message', { count }),
      i_.t('dialogs.remove-title', { entity: 'municipio' })
    ).then(b => {
      if (b) {
        store.delete().then(() => store.query());
      }
    });
  };

  render() {
    return (
      <div>
        <Table
          columns={[
            { label: i_.t('municipio.nome'), field: 'nome' },
            { label: i_.t('municipio.uf'), field: 'uf' },
            { label: i_.t('municipio.codigo-ibge'), field: 'codigoIBGE' },
          ]}
          store={store}
          data={store.list}
          selected={store.selected}
          onAdd={() => store.new()}
          onEdit={() => store.open()}
          onDelete={() => this.handleDelete()}
        />
        <Edit />
      </div>
    );
  }
}

export default observer(Municipio);



// WEBPACK FOOTER //
// ./src/components/municipio/index.js